import { useNavigate } from 'react-router-dom';
import AdminLogin from '../components/AdminLogin';

const AdminLoginPage = () => {
  const navigate = useNavigate();

  const handleLoginSuccess = (adminData) => {
    console.log('✅ Admin autenticado:', adminData);

    // Redirigir al panel de gestión de clientes
    navigate('/manage-clients');
  };

  return (
    <div>
      <AdminLogin onLoginSuccess={handleLoginSuccess} />
    </div>
  );
};

export default AdminLoginPage;
